export default __webpack_public_path__ + "static/nav-floppy-e0f98541a5533d0e60dbd952697ef030.png";